export { type HskLevelTotals, getHskLevelTotals } from "#hsk-level-totals";
